import { gql } from "@apollo/client"
import { useQuery, UseQueryOptions, useMutation, InjectedOptions } from "@oysterhr/core"
import { Engagement, MutationUpdateEmploymentArgs, UpdateEmploymentPayload } from "@oysterhr/schema"
import { GENERAL_STAFF_EMPLOYMENT_PROVIDER_INFORMATION_ENGAGEMENT_FRAGMENT } from "./fragments"

export const GENERAL_STAFF_GET_EMPLOYMENT_PROVIDER_INFORMATION_TAB = gql`
  query GeneralStaffGetEmploymentProviderInformationTab($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      ...GeneralStaffEmploymentProviderInformationEngagementFragment
      languageCode
    }
  }

  ${GENERAL_STAFF_EMPLOYMENT_PROVIDER_INFORMATION_ENGAGEMENT_FRAGMENT}
`

export const useProviderInformation = (
  opts?: UseQueryOptions<{ engagement: Engagement }, { engagementId: string }>,
) =>
  useQuery<{ engagement: Engagement }, { engagementId: string }>(
    GENERAL_STAFF_GET_EMPLOYMENT_PROVIDER_INFORMATION_TAB,
    {
      fetchPolicy: "cache-and-network",
      ignoredErrorCodes: ["429"],
      ...opts,
    },
  )

export const UPDATE_EMPLOYMENT = gql`
  mutation UpdateStaffEmploymentPageProviderInformation($input: UpdateEmploymentInput!) {
    updateEmployment(input: $input) {
      engagement {
        ...GeneralStaffEmploymentProviderInformationEngagementFragment
      }
      employment {
        hiring {
          id
          agreementsSynced
          agreements {
            isAutomated
            state
          }
        }
      }
      errors
    }
  }
  ${GENERAL_STAFF_EMPLOYMENT_PROVIDER_INFORMATION_ENGAGEMENT_FRAGMENT}
`

export const useUpdateProviderInformation = (
  options?: InjectedOptions<
    { updateEmployment: UpdateEmploymentPayload },
    MutationUpdateEmploymentArgs
  >,
) => useMutation(UPDATE_EMPLOYMENT, options)
